<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { useDialog } from 'primevue/usedialog';
import Button from 'primevue/button';
import ConfirmDeleteModal from '@/components/modal/ConfirmDeleteModal.vue';

interface Props {
  record?: any;
  icon?: string;
  labelButton?: string;
  isCityModal?: boolean;
}
const props = defineProps<Props>();

const emits = defineEmits<{ handleDelete: [value: any] }>();

const { t } = useI18n({ useScope: 'global' });
const dialog = useDialog();

const openModalDelete = () => {
  const dialogRef = dialog.open(ConfirmDeleteModal, {
    props: {
      header: t('common.confirm_delete'),
      modal: true,
      style: {
        width: '416px'
      }
    },
    data: {
      title: props.record?.deleteStatus ? t('management.tour.record_deleted_permanently') : t('notification.confirm_delete_message'),
      description: props.isCityModal && !props.record?.deleteStatus ? t('notification.confirm_delete_city_des') : '',
      isAlignCenter: true
    },
    emits: {
      onSave: () => {
        emits('handleDelete', props.record);
        dialogRef.close();
      }
    }
  });
};
</script>

<template>
  <div>
    <Button id="delete-btn" :icon="icon" :label="labelButton" class="p-button-text" @click="openModalDelete()" />
  </div>
</template>
